module.exports = __webpack_public_path__ + "img/youtube.b4ea7f7f.svg";